module.exports = __webpack_public_path__ + "img/worm-happy.02f6f18c.svg";